import { NotificationScopeBadge } from '@ayocore/platform/notifications/client';
import { CONTRACTOR_DOCS_SCOPE } from '../../common/notification-keys';

/**
 * Бейдж пункта меню «Таблицы Подрядчиков» — сколько документов ждут внимания.
 *
 * Счётчик гаснет по одному: карточка документа при открытии отмечает своё
 * уведомление прочитанным (см. `ContractorDocDetail`).
 */
export function ContractorDocsMenuBadge() {
  return <NotificationScopeBadge scope={CONTRACTOR_DOCS_SCOPE} />;
}

export default ContractorDocsMenuBadge;
